import styled from "styled-components";
import Wave from "~/assets/images/Login/ondas.png";

export const Background = styled.div`
  z-index: 1;
  background: #000FFF 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  flex-direction: column;
  
`;

export const GradienteCenter = styled.div`
  z-index: 2;
  position: fixed;
  width: 35%;
  height: 75vh;
  left: 25%;
  background: transparent linear-gradient(270deg, #00FF00 0%, #00FFF6 52%, #00FFFF 100%) 0% 0% no-repeat padding-box;
  background-position: top;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  opacity: 1;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const GradienteMobileImage = styled.div`
  z-index: 2;
  opacity: 1;
  position: fixed;
  width: 100%;
  height: 100vh;
  bottom: -10%;
  background-position: bottom;
  background: url(${Wave}) no-repeat;
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 769px) {
    display: none;
  }
`;

export const Container = styled.div`
  z-index: 3;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  @media screen and (orientation: landscape) {
    height: 100%;
    align-items: center;
  }
  @media (min-width: 769px) {
    height: 100%;
  }
`;

export const Header = styled.div`
  width: 100%;
  justify-content: center;
  padding: 10px 0;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const HeaderMobile = styled.div`
  width: 100%;
  justify-content: center;
  padding: 10px 0;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: 769px) {
    display: none;
  }
`;

export const LeftContainer = styled.div`
  width: 25%;
  height: 100vh;
  @media screen and (max-width: 768px) {
    display: none;
  }
  img {
    padding-top: 45px;
    padding-left: 10%;
    width: 80%;
    height: auto;
    @media (max-width: 1000px) {
      width: 70%;
      padding-left: 6%;
    }
    @media (max-width: 900px) {
      width: 60%;
      padding-left: 4%;
    }
  }
`;

export const ImageCenterContainer = styled.div`
  width: 40%;
  height: 100vh;
  @media screen and (orientation: landscape) {
    height: 100%;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
  img {
    left: 23%;
    position:fixed;
    bottom:0px;
    width: 40%;
    height: auto;
    
    @media (min-width: 1351px) and (min-height: 800px) {
      width: 55%;
      left: 10%;
      top: 5%
    }
    @media (max-width: 1350px) {
      width: 50%;
      left: 10%;
    }
    @media (max-width: 1000px) {
      width: 60%;
      left: 16%;
    }
    @media (max-width: 1350px) and (max-height: 650px) {
      width: 40%;
      left: 23%;
    }
    @media (max-width: 1350px) and (max-height: 650px) {
      width: 40%;
      left: 23%;
    }
    @media (max-width: 1000px) and (max-height: 650px) {
      width: 50%;
      left: 20%;
    }
  }
  `;

export const RightContainer = styled.div`
  @media (min-width: 769px) {
    width: 36%;
    height: 98vh;
    position:fixed;
    top: 0%;
    left: 70%;
  }
  @media (max-width: 769px) {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    align-items: stretch;
  }
  @media (max-height: 590px) {
    top: 5%;
  }
  @media (min-width: 1351px) and (min-height: 800px) {
    top: 2%;
  }
  @media (max-height: 700px) {
    overflow-y: scroll;
  }
`;

export const LoginBox = styled.div`
  width: 70%;
  height: fit-content;
  @media (max-width: 769px) {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    margin-left: 6%;
    margin-right: 2%;
  }
`;

export const Logo = styled.img`
  width: 50%;
  height: auto;
  @media screen and (max-width: 768px) {
    width: 30%;
  }
`;

export const LogoMobile = styled.img`
  width: 60%;
  height: auto;
  @media screen and (min-width: 769px) {
    display: none;
  }
  @media screen and (max-width: 768px) {
    width: 30%;
  }
  @media screen and (max-width: 600px) {
    width: 40%;
  }
  @media screen and (max-width: 450px) {
    width: 50%;
  }
`;

export const LogoMobileFooter = styled.img`
  width: 50%;
  height: auto;
  @media screen and (min-width: 769px) {
    display: none;
  }
  @media screen and (max-width: 768px) {
    width: 30%;
  }
  @media screen and (max-width: 600px) {
    width: 40%;
  }
  @media screen and (max-width: 450px) {
    width: 50%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  min-height: 33%;
  padding: 25px;
  background-color: #fff;
  border-radius: 21px;
  overflow: hidden;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3px 6px #0000005a;

  @media screen and (max-width: 768px) {
    align-items: center;
    width: 96%;
  }
`;

export const LoginTitle = styled.span`
  text-align: center;
  letter-spacing: 0px;
  font: normal normal bold 26px/40px Mangueira;
  color: #000000;
  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const SignInButton = styled.button`
  font: normal normal 600 16px/12px Mangueira;
  letter-spacing: 0px;
  text-transform: lowercase;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 45px;
  background-color: ${(props) => (props.outline ? "transparent" : "#000FFF")};
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  text-align: center;
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  overflow: hidden;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: ${(props) => (props.outline ? "8px" : "10px")};
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }
  img {
    float: left;
    padding-left: 0.8rem;
    width: 30px;
  }
  span {
    font-size: 17px;
    padding-right: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none !important;
    padding-top: ${(props) => (props.outline ? "1px" : "5px")};
  }
`;

export const FirstAccessContainer = styled.div`
`;
